// Gallery dataset.
// source: "real"  -> photo taken on a real job by All Service / Bagnoman (local files)
// source: "stock" -> Unsplash stock image used only to ILLUSTRATE a technique.
//                    Stock images must NEVER be presented as our interventions.
// 2026-10: removed 5 Unsplash images that did not depict the captioned technique
// (CAD screen, gardening, EV charger, living room) or returned 404. Only one
// generic thermal-pattern image is kept, explicitly labelled as stock.
export const gallery = [
  { id: 1, src: "/images/optimized/gallery-1-400.webp", caption_it: "Perdita individuata sotto l'asfalto \u2014 intervento mirato", caption_en: "Leak located under asphalt \u2014 targeted intervention", category: "geofono", source: "real" },
  { id: 2, src: "/images/optimized/intervento-1-400.webp", caption_it: "Localizzazione con Sebakmt HYDROLUX sul pozzetto", caption_en: "Sebakmt HYDROLUX localization on inspection chamber", category: "geofono", source: "real" },
  { id: 3, src: "/images/optimized/gallery-3-400.webp", caption_it: "Strumentazione HYDROLUX in azione \u2014 lettura precisa", caption_en: "HYDROLUX in action \u2014 precision reading", category: "geofono", source: "real" },
  { id: 4, src: "/images/optimized/intervento-2-400.webp", caption_it: "Ricerca perdita in bagno con sonda acustica", caption_en: "Bathroom leak detection with acoustic probe", category: "geofono", source: "real" },
  { id: 5, src: "/images/optimized/gallery-5-400.webp", caption_it: "Geofono HL7000 \u2014 elettroacustica per perdite occulte", caption_en: "HL7000 geophone \u2014 electroacoustic for hidden leaks", category: "geofono", source: "real" },
  { id: 6, src: "/images/optimized/cercaservizi.webp", caption_it: "Mappatura sottoservizi e tubazioni in pressione", caption_en: "Underground utility mapping & pressurized pipes", category: "video", source: "real" },
  { id: 7, src: "https://images.unsplash.com/photo-1698395950317-4590f514be78?auto=format&fit=crop&w=900&q=70", caption_it: "Esempio illustrativo: termografia di una parete", caption_en: "Illustrative example: wall thermography", category: "termocamera", source: "stock", credit: "Immagine di repertorio (Unsplash)" },
];

export const GALLERY_SOURCE_LABEL = {
  real: { it: "Foto di un nostro intervento", en: "Photo from one of our jobs" },
  stock: { it: "Immagine di repertorio (Unsplash) \u2014 non \u00e8 un nostro intervento", en: "Stock image (Unsplash) \u2014 not one of our jobs" },
};

export const galleryReal = gallery.filter((g) => g.source === "real");
export const galleryStock = gallery.filter((g) => g.source === "stock");

export const galleryCategories = [
  { key: "all", label_it: "Tutti", label_en: "All" },
  { key: "geofono", label_it: "Geofono", label_en: "Geophone" },
  { key: "termocamera", label_it: "Termocamera", label_en: "Thermal" },
  { key: "gas", label_it: "Gas tracciante", label_en: "Tracer gas" },
  { key: "tetti", label_it: "Tetti", label_en: "Roofs" },
  { key: "video", label_it: "Video ispezione", label_en: "Video" },
  { key: "antincendio", label_it: "Antincendio", label_en: "Fire systems" },
];

export const interventionVideo = {
  src: "/videos/intervento-reale-ricerca-perdita.mp4",
  poster: "/images/optimized/intervento-1-400.webp",
  title_it: "Intervento reale \u2014 ricerca perdita acqua",
  title_en: "Real intervention \u2014 water leak detection",
};
